<template>
  <o-form-wrapper
    v-model="item"
    :server-errors="_se"
    :v="$v.item"
    :schema="schema"
    :form-state="formState"
  >
    <o-widget-wrapper
      :schema="schema"
      name="allow_view"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-checkbox
        v-model="item.allow_view"
        :form-state="formState"
        name="allow_view"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.allow_view"
      ></o-checkbox>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="allow_create"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-checkbox
        v-model="item.allow_create"
        :form-state="formState"
        name="allow_create"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.allow_create"
      ></o-checkbox>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="allow_update"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-checkbox
        v-model="item.allow_update"
        :form-state="formState"
        name="allow_update"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.allow_update"
      ></o-checkbox>
    </o-widget-wrapper>
  </o-form-wrapper>
</template>

<script>
import schema from "../../schema/index.js";
import { cleanUpModel } from "@/vue-ocom/schema/schema_vuetify.js";

import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
  VuelidateMixin,
} from "@/vue-ocom/mixins";
import { validationMixin } from "vuelidate";
import OWidgetWrapper from "@/vue-ocom/components/forms/OWidgetWrapper.vue";
import OTextField from "@/vue-ocom/components/forms/fields/OTextField.vue";
import ONumberField from "@/vue-ocom/components/forms/fields/ONumberField.vue";
import OSelect from "@/vue-ocom/components/forms/fields/OSelect.vue";
import OCheckbox from "@/vue-ocom/components/forms/fields/OCheckbox.vue";
import OFormWrapper from "@/vue-ocom/components/forms/OFormWrapper.vue";
import ODateTime from "@/vue-ocom/components/forms/fields/ODateTime.vue";

import UseCodeModulesMixin from "@/vue-ocom/mixins/UseCodeModulesMixin.js";

import { default as FormTemplateVersionForm } from "../../form_template_version/components/ItemForm";
export default {
  mixins: [
    VuelidateMixin,
    validationMixin,
    CreateFormStateMixin("$v"),
    CreateGroupPermissionMixin("FormTemplatePermission"),
    UseCodeModulesMixin(["FormTemplateVersion"]),
  ],
  components: {
    OFormWrapper,
    OWidgetWrapper,
    ODateTime,

    OCheckbox,
    OSelect,
    OTextField,
    ONumberField,

    FormTemplateVersionForm,
  },
  props: {
    item: { type: Object, default: () => {} },
    level: { type: Number, default: 0 },
    inModal: { type: Boolean, default: false },
  },
  data: () => ({
    schemaModel: cleanUpModel(schema.FormTemplatePermission, {}),
  }),
  methods: {},
  computed: {
    _se() {
      // Return an empty Object if there are no Server Errors to avoid Binding Errors
      return this.serverErrors || {};
    },
  },
  watch: {},
  created() {},
};
</script>
